/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { ActionDetailsServiceRepositoryImpl } from '../impls/ActionDetailsServiceRepositoryImpl';
import { IActionDetailsServiceRepository } from '../interfaces/IActionDetailsServiceRepository';
import {
    TActionDetailsList,
    TActionDetailsParams,
    TActionDetailsParamsContentId,
    TActionDetailsParamsUnifiedCollection,
} from '../types';
import { TServicesParams } from '../types/TServicesParams';

export class ActionDetailsService implements IActionDetailsServiceRepository {
    private oActionDetailsServiceRepository: IActionDetailsServiceRepository;

    constructor(params: TServicesParams) {
        this.oActionDetailsServiceRepository = new ActionDetailsServiceRepositoryImpl(params);
    }

    public async fetchContentActionDetails(
        actionDetailsParams: TActionDetailsParamsContentId,
    ): Promise<TActionDetailsList> {
        return this.oActionDetailsServiceRepository.fetchContentActionDetails(actionDetailsParams);
    }

    async fetchOfferActionDetails(
        actionDetailsParams: TActionDetailsParams,
    ): Promise<TActionDetailsList> {
        return this.oActionDetailsServiceRepository.fetchOfferActionDetails(actionDetailsParams);
    }

    async fetchUnifiedCollectionActionDetails(
        unifiedCollectionParams: TActionDetailsParamsUnifiedCollection,
    ): Promise<TActionDetailsList> {
        return this.oActionDetailsServiceRepository.fetchUnifiedCollectionActionDetails(
            unifiedCollectionParams,
        );
    }
}
